import { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

import { Loading } from "@smart/itops-sb-design-system-dom";

import { FormPrintContent } from "./form-print-content";
import { useLoadFormWithLoadingStatus } from "../../create-form/creation-status";

export const usePrintForm = ({
  formUri = "",
  onPrinted,
}: {
  formUri: string | undefined;
  onPrinted: () => void;
}) => {
  const { form, sections, groups, fields } = useLoadFormWithLoadingStatus({
    formUri,
    shouldCheck: false,
  });
  const [printing, setPrinting] = useState(false);

  const printContentRef = useRef(null);

  const handlePrint = useReactToPrint({
    contentRef: printContentRef,
    documentTitle: form.result?.formTitle,
    preserveAfterPrint: true,
    onBeforePrint: () =>
      new Promise((resolve) => {
        setPrinting(true);
        resolve(undefined);
      }),
    onAfterPrint: () => {
      setPrinting(false);
      onPrinted();
    },
  });

  useEffect(() => {
    if (
      formUri &&
      !form.loading &&
      !sections.loading &&
      !groups.loading &&
      !fields.loading
    ) {
      handlePrint();
    }
  }, [formUri, form.loading, sections.loading, groups.loading, fields.loading]);

  return {
    printFormContent: (
      <>
        <FormPrintContent
          ref={printContentRef}
          formTitle={form.result?.formTitle}
          sections={sections.result}
          groups={groups.result}
          fields={fields.result?.filter(
            (field) =>
              !["payment", "appointment", "file"].includes(field.values.type),
          )}
        />
        {printing && (
          <div className="fixed inset-0 z-100">
            <Loading />
          </div>
        )}
      </>
    ),
  };
};
